const overview = [
  {
    "title": "Become a Web Developer in 24 Weeks",
    "date": "Classes Begin 04/21/2018",

    "overview":
      "ProCode is a Weekend Coding Boot Camp designed to help students " +
      "develop the expertise and professional network " +
      "needed to capitalize on the high-demand web " +
      "development career track. We offer a wide " +
      "range of in-demand skills and career services " +
      "to prepare you for success with industry " +
      "teachers and mentoring to get you hired.",


    "slider": [
        "Not Just a Coding Course, we work to Get you Hired!",
        "Study part-time on weekends while maintaining your work schedule.",
        "Build Real World Responsive Web Applications for all devices – Desktop, laptop, tablets " +
        "and smart phones for big name companies such as Cisco, LinkdIn, Tivo etc.",
        "Average Starting Salary for Front End Developer is $85K - 105K a year!",
        "We Teach You Latest JavaScript Frameworks and Libraries",
        "Learn HTML5, CSS3, JavaScript, jQuery, Bootstrap, Express.js, React.js, Node.js, Database Theory, Redux, FireBase, Command Line, Git, GitHub and more.* " +
        "*The material covered in this course is subject to change due to market demand",
    ]
  },
];
export default overview;


// WEBPACK FOOTER //
// ./src/OverviewData.js